module.exports = __webpack_public_path__ + "static/media/cubes.cfc94c43.jpg";